export const offset = (elId) => {
  var el = document.getElementById(elId)
  if (!el) return 0
  var rect = el.getBoundingClientRect()
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

export default (directives, scrollPos) => {
  let activeElements = {}
  directives.forEach((a, i) => {
    let start = offset(a.start)
    let end = offset(a.end)
    if (scrollPos >= start.top && scrollPos < end.top) {
      activeElements[a.id] = 'fixed'
    } else {
      if (scrollPos < start.top) {
        activeElements[a.id] = 'start'
      }
      if (scrollPos >= end.top) {
        activeElements[a.id] = 'end'
      }
    }
  })
  return activeElements
}
